module.exports = __webpack_public_path__ + "static/media/analytics.0d0da9f2.png";